export default async function fetchWithAuth(url, options = {}) {
  const token = localStorage.getItem('authToken');

  const headers = options.headers || {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401 || response.status === 403) {
    // Token expired or invalid
    localStorage.removeItem('authToken');
    window.location.href = '/login?sessionExpired=true';
    return null; // Stop further processing
  }

  return response;
}
